<form [formGroup]="fb" (ngSubmit)="submit()" (click)="onTouched()">
  <div class="text-container">
    <div>
      <c-input [label]="'my-profile.first-name' | transloco" formControlName="firstName"> </c-input>
      <c-input [label]="'my-profile.last-name' | transloco" formControlName="lastName"></c-input>
      <c-phone [label]="'my-profile.phone-number' | transloco" formControlName="phoneNumber" [preferredCountries]="preferredCountries"></c-phone>
    </div>
  </div>
</form>
